import React from 'react';
import styled from 'styled-components';
import MobileMenu from "../MobileMenu";
import logoImg from '../../../../../assets/img/logo/logo.webp'
import RenderMedia from "../../../../media/renderMedia";
import logo from "../../../../../assets/img/logo/logoLine.webp";


const Ul = styled.ul`
    list-style: none;
    overflow-y: auto;
    font-size: 15px;
    display: flex;
    flex-flow: row nowrap;
    padding-right: 0;

    li {
        padding: 18px 10px;
    }

    flex-flow: column nowrap;
    background-color: #fff;
    box-shadow: 0px 5px 10px 3px rgba(51, 51, 51, 0.15);
    position: fixed;
    transform: ${({open}) => open ? 'translateX(0)' : 'translateX(100%)'};
    top: 0;
    right: ${({open}) => open ? '0' : "-100%"};
    height: 101vh;
    width: 270px;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    z-index: 99998;

    li {
        color: #000;
    }
`;

const RightNav = ({logo, toggle, open}) => {

    return (
        <>
            <Ul open={open}>
                <div className="text-center">
                    <img src={logo} alt="logo" title="logo" width={100}/>
                </div>
                <MobileMenu toggleMenu={toggle}/>
                <div className='nav-social mb-3'>
                    <RenderMedia />
                </div>
            </Ul>

        </>
    )
}

export default RightNav
